declare namespace $ {

	export class $bog_fragile_demo_rename_base1 extends $mol_view {
		heading( ): string
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=base1.view.tree.d.ts.map